import { parseAsString, useQueryState } from "nuqs";

export const useTableSelect = () => {
  const [selectedTableId, setSelectedTableId] = useQueryState(
    "table",
    parseAsString
  );

  return { selectedTableId, setSelectedTableId };
};
